

















import { Component, Vue, Prop } from "vue-property-decorator";
import { RedCapital, SelectedCountry, RedCapitalConfig } from "@/configuration";
import { EventBus } from "@/main";
import Api from '@/api'

function cleanValue(value: any) {
  if(value != null){
    return value.toString().replace(/[.|,]/gi, "");
  }else{
    return "";
  }
}

function currencyParser(value: any) {
  let cValue = cleanValue(value);
  return cValue.length == 4
    ? `${cValue[0]}.${cValue
        .split("")
        .slice(1, 4)
        .join("")}`
    : Number(cValue).toLocaleString(
        RedCapitalConfig(SelectedCountry).Currency.LocaleString
      );
}

Vue.directive("currency-parser", {
  bind(el, binding) {
    const inputEvents = ["keypress"];

    let formatter = (e: any) => {
      if (e.key.match(/[^0-9]/gim)) {
        e.preventDefault();

      }

      let value = e.target.value.replace(/[^0-9]/gim, "");
      if (Number.isNaN(Number(value))) {
        e.target.value = 1000000;
      } else {
        e.target.value = currencyParser(value);
      }
    };

    inputEvents.forEach(event => {
      el.addEventListener(event, formatter);
    });
  }
});

@Component({
  computed: {
    minAndMax() {
      return [
        (v: any) =>
          Number(cleanValue(v)) >= this.$props.min ||
          `El monto es menor a <a onclick="SetAmount(${this.$props.min}, ${
            this.$data.uuid
            // @ts-ignore
          })">${this.$options.filters.currency(this.$props.min)}</a>`,
        (v: any) =>
          Number(cleanValue(v)) <= this.$props.max ||
          `El monto es mayor a <a onclick="SetAmount(${this.$props.max}, ${
            this.$data.uuid
            // @ts-ignore
          })">${this.$options.filters.currency(this.$props.max)}</a>`
      ];
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      money: 0,
      isFocus: false,
      uuid: Math.random()
    };
  },
  watch: {
    value(val) {
      this.$data.money = Number(cleanValue(this.$props.value)).toLocaleString(
        RedCapitalConfig(SelectedCountry).Currency.LocaleString
      );
      // @ts-ignore
      this.onChange();
    },
    money(val) {
      // @ts-ignore
      this.onChange();
    }
  },
  created() {
    this.$data.money = Number(cleanValue(this.$props.value)).toLocaleString(
      RedCapitalConfig(SelectedCountry).Currency.LocaleString
    );
  },
  beforeMount() {
    // @ts-ignore
    window.SetAmount = (amount: any, uuid: any) => {
      Api.registraranalytics('Simulacion proyecto',this.$store.state.ip, 'boton un millon',this.$store.state.user != null ? this.$store.state.user.id : 0,'' ,this.$data.money)
      .then(res => {
       res
      })
      .catch(err => {})
      if (this.$data.uuid == uuid) {
        this.$data.money = amount;
      }

    };
  },
  mounted() {
  
  },
  methods: {
    autoformat() {
      /* console.log(Number(cleanValue(this.$data.money)))
      console.log(this.$props.min)
      console.log(this.$props.max)
      if(Number(cleanValue(this.$data.money)) > this.$props.max) {
        this.$data.money = this.$props.max
        EventBus.$emit('snack-error','testmax')
      }
      if(Number(cleanValue(this.$data.money)) < this.$props.min) {
        this.$data.money = this.$props.min
        EventBus.$emit('snack-error','testmin')
      } */
    },
    format(val: any) {
      // @ts-ignore
      return this.$options.filters.currency(val);
    },
    setThing() {
      /* console.log(this) */
    },
    onChange() {
      /* isFocused:false */
      this.$emit("input", Number(cleanValue(this.$data.money)));
    },
    focus() {
      this.$emit("focus");
      this.$data.isFocus = true;
    },
    blur() {
      this.$emit("blur");
      this.$data.isFocus = false;
    }
  }
})
export default class Currency extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: -1000000000000 }) min!: number;
  @Prop({ default: 1000000000000 }) max!: number;
  @Prop() label!: string;
}
